

export interface CreateAccountDto
{
    getMsisdn(): string;
    getEncryptedPassword():string;
    getLanguage(): string;
    getClientTxnId(): string;
    getUserName(): string;
    getEmail(): string;
    getCategoryId(): string;
    getSecurityCounter(): string;
    getPassword(): string;
    getRespDesc(): string;
    getTxnId(): string;
    getSrvType(): string;//Name of API service
    getSecToc(): string; //Section Token
}

export class CreateAccountDtoImpl implements CreateAccountDto
{
    private msisdn: string;
    private encryptedPassword: string;
    private language: string;
    private clientTxnId: string;
    private userName: string;
    private email: string;
    private categoryId: string;
    private securityCounter: string;

    private respDesc: string;
    private txnId: string;
    private srvType: string;
    private secToc: string;
    private password: string;

    getMsisdn(): string 
    {
        return this.msisdn;
    }
    setMsisdn(msisdn: string)
    {
        this.msisdn = msisdn;
    }

    getEncryptedPassword(): string 
    {
        return this.encryptedPassword;
    }
    setEncryptedPassword(encryptedPassword: string)
    {
        this.encryptedPassword = encryptedPassword;
    }

    setPassword(password: string)
    {
        this.password = password;
    }

    getPassword(): string {
       return this.password;
    }
    getLanguage(): string 
    {
        return this.language;
    }
    setLanguage(language: string)
    {
        this.language = language;
    }

    getClientTxnId(): string 
    {
        return this.clientTxnId;
    }
    setClientTxnId(clientTxnId: string)
    {
        this.clientTxnId = clientTxnId;
    }

    getUserName(): string 
    {
        return this.userName;
    }
    setUserName(userName: string)
    {
        this.userName = userName;
    }

    getEmail(): string 
    {
        return this.email;
    }
    setEmail(email: string)
    {
        this.email = email;
    }

    getCategoryId(): string 
    {
        return this.categoryId;
    }
    setCategoryId(categoryId: string)
    {
        this.categoryId = categoryId;
    }

    getSecurityCounter(): string 
    {
        return this.securityCounter;
    }
    setSecurityCounter(securityCounter: string)
    {
        this.securityCounter = securityCounter;
    }

    getRespDesc(): string {
        return this.respDesc;
    }
    setRespDesc(respDesc: string) {
        this.respDesc = respDesc;
    }

    getTxnId(): string {
        return this.txnId;
    }
    setTxnId(txnId: string) {
        this.txnId = txnId;
    }

    getSrvType(): string {
        return this.srvType;
    }
    setSrvType(srvType: string) {
        this.srvType = srvType;
    }

    getSecToc(): string {
        return this.secToc;
    }
    setSecToc(secToc: string) {
        this.secToc = secToc;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/createaccount/createaccountdto.tsx